<template>
  <v-row>
    <v-col
      v-for="(item, index) in items"
      :key="`card-` + item.ref_id + `-` + index"
      cols="12" 
      sm="6"
      md="4"
      class="py-2"
    >
      <v-card
        class="game-card"
      >
        <div class="event-result-ELO card h-max divide-y col-span-2">
          <div class="card-title justify-start gap-2 py-2">
            <div class="flex items-center gap-2">
              <div class="w-40">
                <v-img 
                  :src="item.room ? imagePath(item.room.game_id, item.room.name) : ''"
                />
              </div>
              <div class="flex flex-col justify-center">
                <span class="lotto-type">
                  {{ item.room ? item.room.name : '-' }}
                </span>
                <span class="lotto-date text-sm">{{ item.created_at | dateOnlyFormat }}</span>
              </div>
              <strong 
                class="lotto-status" 
                :class="statusClass(item)"
              >
                <template v-if="item.stake_status.name == 'แทง'">
                  รอออกผล
                </template>
                <template v-else>
                  {{ item.stake_status.name }}
                </template>
              </strong>
            </div>
          </div>
          <v-divider class="divider-i my-1"></v-divider>
          <div class="flex items-center justify-space-between gap-2 py-2">
            <div class="result-info">
              <span>เดิมพัน</span>
              <strong>{{ item.bet_amount | currency }}</strong>
            </div>
            <div class="result-info">
              <span>ถูกรางวัล</span>
              <strong>{{ item.win_amount | currency }}</strong>
            </div>
            <div class="result-info">
              <button
                class="icon"
                type="button"
                @click="viewLotto(item)"
              >
                <div class="flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none" 
                    viewBox="0 0 24 24"
                    stroke="#fff"
                    stroke-width="2"
                    width="24"
                    height="24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round" 
                      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021
           M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
                    />
                  </svg>
                </div>
              </button>
            </div>
          </div>
          <v-divider class="divider-i my-1"></v-divider>
          <div class="flex items-center justify-space-between gap-2 mt-2">
            <div class="result-type">
              #{{ item.ref_id.substring(0, 8) }}
            </div>
            <span class="result-value font-semibold">{{ item.created_at | dateFormat }}</span>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { imagePath } from '@/plugins/mapImage' 

export default {
  props : {
    items : {
      type: Array,
      default: () => ([1])
    },
  },
  methods: {
    imagePath,
    viewLotto (item) {
      this.$emit('detail', item)
    },
    statusClass (item) {

      if (item.stake_status.name == 'แทงไม่ถูก') {
        return 'red-x--text'
      } else if (item.stake_status.name == 'ยกเลิกโพย') {
        return 'red-x--text'
      } else if (item.stake_status.name == 'แทง') {
        return 'yellow-x--text'
      } else if (item.stake_status.name == 'ถูกรางวัล') {
        return 'green--text'
      }

      return 'gray-x--text'
    }
  },
}
</script> 
<style scoped>

.card {
  background-color: var(--bg-secondary-color-v2);
  /* border-style: none; */
  border-radius: 1rem !important;
  /* box-shadow: 0 10px 15px -3px #0000001a, 0 4px 6px -4px #0000001a; */
  height: auto;
  padding: 0.75rem;
}

.w-40 {
  width: 40px;
}

.lotto-type {
  font-weight: bold;
  font-size: 1.125rem;
}

.lotto-date  {
  font-weight: bold;
}

.lotto-status {
  background-color: white;
  border-radius: 12px;
  padding: 4px 8px;
  font-size: 0.925rem;
}

.result-type, .result-value {
  font-size: 0.8125rem;
  font-weight: bold;
}

.result-info {
  display: flex;
  flex-direction: column;
}

.icon {
  width: 30px;
  height: 30px;
  background-color: black;
  border-radius: 4px;
  padding: 4px;
}

.game-card {
  box-shadow: unset !important;
  background: unset !important;
}

.divider-i {
  border-color: #2e1e1e;
  height: 1px;
}

</style>